module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"addTeamDialogBtn":"Ajouter une équipe"},"en":{"addTeamDialogBtn":"Add a team"}}')
  delete Component.options._Ctor
}
